export type UserColorToken = {
  bg: string;
  border: string;
  text: string;
  badgeBg: string;
  badgeText: string;
};

const USER_COLOR_PALETTE: UserColorToken[] = [
  { bg: "hsl(220 100% 96%)", border: "hsl(221 85% 78%)", text: "hsl(222 80% 44%)", badgeBg: "hsl(220 100% 92%)", badgeText: "hsl(222 75% 38%)" },
  { bg: "hsl(167 72% 94%)", border: "hsl(168 60% 73%)", text: "hsl(170 80% 30%)", badgeBg: "hsl(168 72% 89%)", badgeText: "hsl(170 70% 26%)" },
  { bg: "hsl(32 100% 94%)", border: "hsl(31 90% 74%)", text: "hsl(28 88% 40%)", badgeBg: "hsl(32 100% 89%)", badgeText: "hsl(28 82% 33%)" },
  { bg: "hsl(284 82% 95%)", border: "hsl(283 70% 78%)", text: "hsl(282 60% 39%)", badgeBg: "hsl(284 80% 90%)", badgeText: "hsl(282 58% 32%)" },
  { bg: "hsl(350 100% 95%)", border: "hsl(351 88% 79%)", text: "hsl(349 76% 42%)", badgeBg: "hsl(350 100% 91%)", badgeText: "hsl(349 72% 35%)" },
  { bg: "hsl(49 100% 92%)", border: "hsl(45 92% 72%)", text: "hsl(37 90% 34%)", badgeBg: "hsl(49 100% 86%)", badgeText: "hsl(37 78% 30%)" },
  { bg: "hsl(191 84% 94%)", border: "hsl(192 70% 75%)", text: "hsl(194 84% 32%)", badgeBg: "hsl(191 80% 89%)", badgeText: "hsl(194 75% 28%)" },
  { bg: "hsl(141 70% 93%)", border: "hsl(141 58% 73%)", text: "hsl(141 70% 30%)", badgeBg: "hsl(141 66% 88%)", badgeText: "hsl(141 64% 26%)" },
];

const NEUTRAL_COLOR: UserColorToken = {
  bg: "hsl(220 15% 94%)",
  border: "hsl(220 15% 82%)",
  text: "hsl(220 22% 28%)",
  badgeBg: "hsl(220 16% 90%)",
  badgeText: "hsl(220 24% 25%)",
};

const normalizeSeed = (value?: string | null) => (value ?? "").trim().toLowerCase();

const hashSeed = (seed: string) => {
  let hash = 5381;
  for (let index = 0; index < seed.length; index += 1) {
    hash = (hash * 33) ^ seed.charCodeAt(index);
  }
  return Math.abs(hash);
};

export const getUserColorToken = (seed?: string | null): UserColorToken => {
  const normalized = normalizeSeed(seed);
  if (!normalized) return NEUTRAL_COLOR;
  const index = hashSeed(normalized) % USER_COLOR_PALETTE.length;
  return USER_COLOR_PALETTE[index];
};

export const getUserInitials = (name?: string | null): string => {
  const value = (name ?? "").trim();
  if (!value) return "?";
  const parts = value.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0][0] ?? ""}${parts[1][0] ?? ""}`.toUpperCase();
};

